class LocationService {

  constructor(ApiService, $q, LocationSchema, Upload) {
    this.$q = $q;
    this.ApiService = ApiService;
    this.Upload = Upload;
    this.LocationSchema = LocationSchema;

    this.endpoint = '/api/locations';
    this.imageEndpoint = "/api/upload";

    this.deletedynamicLinkImageEndpoint = "/api/dynamiclinks/deleteimage";
  }

  addImage(location, files, type, filesToRemove) {

    var self = this;

    if (files[type]) {
      var endpointType = type.toLowerCase().startsWith('dynamiclink') ? 'dynamic_link' : type;
      return self.Upload.upload({
        url: self.imageEndpoint + '/' + endpointType,
        data: { file: files[type] }
      }).then((response) => {
        if (response) {
          if (type == 'location') {
            // add image details to location object
            location.largeImageUrl = response.data.large_image.url;
            location.mediumImageUrl = response.data.medium_image.url;
          }
          else if (type == 'pin') {
            location.pinImageUrl = response.data.image.url;
          }
          else if (type == 'dynamicLink1') {
            location.dynamicLink1.imageUrl = response.data.image.url;
          }
          else if (type == 'dynamicLink2') {
            location.dynamicLink2.imageUrl = response.data.image.url;
          }
          return location;
        } else {
          return self.$q.reject({ type: 'image', field: type, message: type + ' image has incorrect dimensions' });
        }
      }).catch((response) => {
        var error = { type: 'image', field: type, message: "Unknown error saving the location or associated image" };
        if (response.data.error) {
          error.message = response.data.message;
        }
        return self.$q.reject(error);
      });
    }
    else {
      if (filesToRemove && filesToRemove['location']) {
        location.largeImageUrl = '';
        location.mediumImageUrl = '';
      }
      if (filesToRemove && filesToRemove['pin']) {
        location.pinImageUrl = '';
      }
      if (filesToRemove && filesToRemove['dynamicLink1']) {
        location.dynamicLink1.imageUrl = '';
      }
      if (filesToRemove && filesToRemove['dynamicLink2']) {
        location.dynamicLink2.imageUrl = '';
      }
      return self.$q.when(location);
    }

  }

  /**
   * Send new location to server
   * @param   {*} location
   * @param   {*} files
   *
   * @returns {*}
   */
  addNew(location, files) {
    return this.submit(location, files, 'post');
  }

  /**
   * Send edited location to server
   * @param   {*} location
   * @param   {*} files
   *
   * @returns {*}
   */
  update(location, files, filesToRemove) {
    return this.submit(location, files, 'put', filesToRemove);
  }

  /**
   * Submit location to server
   * @param   {*}         location
   * @param   {*}         files
   * @param   {String}    mode
   *
   * @returns {*}
   */
  submit(location, files, mode, filesToRemove) {

    var self = this;

    // save the images
    return self.addImage(location, files, 'location', filesToRemove).then(function (location) {
      return self.addImage(location, files, 'pin', filesToRemove).then(function (location) {

        // get object ready
        var readyData = self.stripUnnecessaryFields(location);

        // save the location
        var endpoint = self.endpoint;
        if (mode == 'put') {
          endpoint += '/' + location.id;
        }
        return self.ApiService[mode](endpoint, readyData).then(
          function (locationResponse) {
            location.id = locationResponse.data.id;
          }
        ).then(
          function () {
            return self.addImage(location, files, 'dynamicLink1', filesToRemove);
          }
        ).then(
          function (location) {
            if (location.dynamicLink1 && !!location.dynamicLink1.name.trim() && !!location.dynamicLink1.url.trim()) {
              return self.saveDynamicLink(location.id, location.dynamicLink1)
                .then(function (dynamicLink1Response) {
                  location.dynamicLink1 = dynamicLink1Response;
                });
            } else if (location.dynamicLink1.id) {
              return self.deleteDynamicLink(location.id, location.dynamicLink1.id)
                .then(function () {
                  location.dynamicLink1 = { id: null, name: "", url: "", imageUrl: "" };
                });
            }
          }
        ).then(
          function () {
            return self.addImage(location, files, 'dynamicLink2', filesToRemove);
          }
        ).then(
          function (location) {
            if (location.dynamicLink2 && location.dynamicLink2.name !== '' && location.dynamicLink2.url != '') {
              return self.saveDynamicLink(location.id, location.dynamicLink2)
                .then(function (dynamicLink2Response) {
                  location.dynamicLink2 = dynamicLink2Response;
                });
            } else if (location.dynamicLink2.id) {
              return self.deleteDynamicLink(location.id, location.dynamicLink2.id)
                .then(function () {
                  location.dynamicLink2 = { id: null, name: "", url: "", imageUrl: "" };
                });
            }
          }
        ).then(
          function () { return location; }
        );
      });
    });

  }

  getAll() {
    var self = this;
    return self.ApiService.get(self.endpoint)
      .then((response) => { return response.data });
  }

  getById(id) {
    var self = this;
    return self.ApiService.get(self.endpoint + '/' + id)
      .then((response) => {
        //format returned array of dynamic links in to specific properties
        if (response.data.buttons) {
          if (response.data.buttons[0]) {
            response.data.dynamicLink1 = response.data.buttons[0];
          }
          if (response.data.buttons[1]) {
            response.data.dynamicLink2 = response.data.buttons[1];
          }
        }

        if (!response.data.dynamicLink1) {
          response.data.dynamicLink1 = { id: null, name: "", url: "", imageUrl: "" };
        }
        if (!response.data.dynamicLink2) {
          response.data.dynamicLink2 = { id: null, name: "", url: "", imageUrl: "" };
        }
        return response.data;
      });
  }

  getNew() {
    return this.LocationSchema;
  }

  deleteLocation(locationId) {
    var self = this;
    return self.ApiService._delete(this.endpoint + '/' + locationId);
  }

  stripUnnecessaryFields(location) {
    var formattedLocation = {
      "id": location.id,
      "name": location.name,
      "description": location.description,
      "largeImageUrl": location.largeImageUrl,
      "mediumImageUrl": location.mediumImageUrl,
      "pinImageUrl": location.pinImageUrl,
      "websiteUrl": location.websiteUrl,
      "lat": location.lat,
      "lng": location.lng,
      "keywords": location.keywords,
      "access": location.access,
      "type": location.type,
      "filter": location.filter,
      "isMcc": location.isMcc,
      "active": location.active
    };
    return formattedLocation;
  }

  /**
    * Save dynamicLink on server
    * @param locationId
    * @param dynamicLink
    * @returns {*}
    */
  saveDynamicLink(locationId, dynamicLink) {
    var self = this;
    var readyData = self.stripUnnecessaryDynamicLinkFields(dynamicLink);
    if (dynamicLink.id && dynamicLink.id !== '' && dynamicLink.id > 0) {
      return self.ApiService.put(self.endpoint + '/' + locationId + '/dynamiclink/' + dynamicLink.id, readyData);
    } else {
      return self.ApiService.post(self.endpoint + '/' + locationId + '/dynamiclink', readyData);
    }
  }

  /**
    * Delete dynamicLink from server
    * @param locationId
    * @param dynamicLinkId
    * @returns {*}
    */
  deleteDynamicLink(locationId, dynamicLinkId) {
    var self = this;
    return self.ApiService._delete(self.endpoint + '/' + locationId + '/dynamiclinks/' + dynamicLinkId);
  }

  stripUnnecessaryDynamicLinkFields(dynamicLink) {
    var formattedDynamicLink = {
      "id": dynamicLink.id,
      "name": dynamicLink.name,
      "url": dynamicLink.url,
      "imageUrl": dynamicLink.imageUrl,
      "type": "location"
    };
    return formattedDynamicLink;
  }

}

LocationService.$inject = ['ApiService', '$q', 'LocationSchema', 'Upload'];
export default LocationService;
